export const sumByField =
  (fieldKey: string, init = 0) =>
    (entities: any) =>
      entities.reduce((acc: any, { [fieldKey]: val }: any) => acc + val, init);
